export const STORAGE_KEY = 'zen-protocol-contract-naming';
